// ✅ نسخه به‌روزرسانی‌شده SelectServices.js با قابلیت انتخاب آدرس موقت در صورت نیاز

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "./SelectServices.css";
import logo from './assets/Logo.png';

function SelectServices() {
    const [user, setUser] = useState(null);
    const [services, setServices] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [availableDates, setAvailableDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [availableTimes, setAvailableTimes] = useState([]);
    const [selectedTime, setSelectedTime] = useState("");
    const [comment, setComment] = useState("");
    const [servicesOpen, setServicesOpen] = useState(false);

    const [useCurrentAddress, setUseCurrentAddress] = useState(null);
    const [tempAddress, setTempAddress] = useState("");
    const [tempPostalCode, setTempPostalCode] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = localStorage.getItem("userData");
        document.body.classList.remove('dropdown-open');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
        fetch("https://carcure.ca/backend/services")
            .then(res => res.json())
            .then(data => setServices(data))
            .catch(err => console.error("❌ Error fetching services:", err));

        fetch("https://carcure.ca/backend/available-dates")
            .then(res => res.json())
            .then(data => {
                const now = new Date();
                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                const workingHoursStartM = 8 * 60;
                const workingHoursEndM = 20 * 60;
                const sixHours = 6 * 60;
                const currentDateStr = now.toLocaleDateString('en-CA');

                let effectiveCurrent = currentMinutes < workingHoursStartM ? workingHoursStartM : currentMinutes;
                let thresholdToday = effectiveCurrent + sixHours;

                if (thresholdToday > workingHoursEndM) {
                    data = data.filter(date => date !== currentDateStr);
                }
                setAvailableDates(data);
            })
            .catch(err => console.error("❌ Error fetching available dates:", err));
    }, []);

    const toggleServicesDropdown = () => {
        setServicesOpen(prev => {
            document.body.classList.toggle('dropdown-open', !prev);
            return !prev;
        });
    };

    const fetchAvailableTimes = (date) => {
        setSelectedDate(date);
        setSelectedTime("");
        setUseCurrentAddress(null);
        fetch(`https://carcure.ca/backend/available-times/${date}`)
            .then(res => res.json())
            .then(data => {
                const workingHoursStartM = 8 * 60;
                const workingHoursEndM = 20 * 60;
                const sixHours = 6 * 60;
                const pad = n => n.toString().padStart(2, '0');
                const now = new Date();
                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                const currentDateStr = now.toLocaleDateString('en-CA');

                let thresholdM;
                if (date === currentDateStr) {
                    let effectiveCurrent = currentMinutes < workingHoursStartM ? workingHoursStartM : currentMinutes;
                    thresholdM = effectiveCurrent + sixHours;
                    if (thresholdM > workingHoursEndM) thresholdM = 9999;
                } else {
                    const tomorrowStr = new Date(now.getTime() + 86400000).toLocaleDateString('en-CA');
                    if (date === tomorrowStr) {
                        let effectiveCurrent = currentMinutes < workingHoursStartM ? workingHoursStartM : currentMinutes;
                        let remainingToday = Math.max(0, workingHoursEndM - effectiveCurrent);
                        let extraNeeded = Math.max(0, sixHours - remainingToday);
                        thresholdM = workingHoursStartM + extraNeeded;
                    } else {
                        thresholdM = workingHoursStartM;
                    }
                }

                const thresholdTime = pad(Math.floor(thresholdM / 60)) + ":" + pad(thresholdM % 60);
                let filteredTimes = data.filter(time => time >= thresholdTime && time >= "08:00" && time <= "20:00");
                setAvailableTimes(filteredTimes);
            })
            .catch(err => console.error("❌ Error fetching available times:", err));
    };

    const handleServiceSelection = (service) => {
        setSelectedServices(prevSelected =>
            prevSelected.includes(service)
                ? prevSelected.filter(item => item !== service)
                : [...prevSelected, service]
        );
    };

    const handleConfirm = async () => {
        const selectedCar = JSON.parse(localStorage.getItem("selectedCar"));
        if (!selectedCar) return alert("❌ Vehicle information not found.");
        if (!selectedDate) return alert("❌ Please select a date.");
        if (!selectedTime) return alert("❌ Please select a time.");
        if (selectedServices.length === 0) return alert("❌ Please select at least one service.");
        if (useCurrentAddress === null) return alert("❌ Please specify whether service should be provided at the registered address.");
        if (useCurrentAddress === false && (!tempAddress || !tempPostalCode)) {
            return alert("❌ Please enter temporary address and zip code..");
        }

        const requestData = {
            email: user?.Email,
            name: user?.Name,
            phone: user?.Phone,
            address: user?.Address,
            brand: selectedCar.Brand,
            model: selectedCar.Model,
            year: selectedCar.Year,
            trim: selectedCar.Trim,
            services: selectedServices.map(service => service["Service Name"]),
            totalPrice: selectedServices.reduce((sum, service) => sum + (service["Price ($)"] || 0), 0),
            Comment: comment,
            date: selectedDate,
            time: selectedTime,
            TempAddress: useCurrentAddress ? user?.Address : tempAddress,
            TempPostalCode: useCurrentAddress ? "" : tempPostalCode,
        };

//*------------------------------------------------------------*//
if (useCurrentAddress === false) {
  const postalRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
  if (!postalRegex.test(tempPostalCode)) {
    return alert("❌ Postal code format is invalid! Use format like K9H 0K1.");
  }

  const postalPrefix = tempPostalCode.replace(/\s/g, "").substring(0, 3).toUpperCase();

  const areaResponse = await fetch("https://carcure.ca/backend/check-working-area", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ postalPrefix })
  });

  const areaResult = await areaResponse.json();
  if (!areaResult.found) {
    return alert("❌ Sorry, service is not available in the area of the temporary address you provided.");
  }
}



//*------------------------------------------------------------*//


        try {
            const response = await fetch("https://carcure.ca/backend/confirm-order", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData)
            });
            const data = await response.json();
            alert(data.message);
            if (data.message.includes("✅")) {
                navigate("/customer-dashboard");
            }
        } catch (error) {
            console.error("❌ Error confirming order:", error);
            alert("An error occurred while confirming the order.");
        }
    };

    return (
        <div className="select-services-container">
            <div className="logo-container">
                <img src={logo} alt="Logo" className="login-logo" />
                <hr />
            </div>

            <h1>🛠 Select Services & Schedule Appointment</h1>

            <div className="form-sections">
                <div className="services-dropdown-container">
                    <label>Select Services:</label>
                    <div className="services-dropdown-button" onClick={toggleServicesDropdown}>
                        {servicesOpen ? "Close Services " : "Choose Service "}
                        <span className="dropdown-arrow">{servicesOpen ? "▴" : "▾"}</span>
                    </div>
                    {servicesOpen && (
                        <div className="services-dropdown">
                            {services.map((service, index) => (
                                <label key={index} className="service-item">
                                    <input
                                        type="checkbox"
                                        checked={selectedServices.includes(service)}
                                        onChange={() => handleServiceSelection(service)}
                                    />
                                    <span>{service["Service Name"]} - ${service["Price ($)"]}</span>
                                </label>
                            ))}
                        </div>
                    )}
                </div>

                <div className="comment-container">
                    <label htmlFor="comment">Comment (Optional):</label>
                    <textarea
                        id="comment"
                        maxLength="150"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Write your comment here (max 150 characters)..."
                    />
                </div>

                <div className="date-time-section">
                    <div className="dropdown-container">
                        <label>Select Date:</label>
                        <select onChange={(e) => fetchAvailableTimes(e.target.value)} value={selectedDate}>
                            <option value="">Choose Date</option>
                            {availableDates.map((date, index) => (
                                <option key={index} value={date}>{date}</option>
                            ))}
                        </select>
                    </div>

                    {selectedDate && availableTimes.length > 0 && (
                        <div className="dropdown-container">
                            <label>Select Time:</label>
                            <select onChange={(e) => setSelectedTime(e.target.value)} value={selectedTime}>
                                <option value="">Choose Time</option>
                                {availableTimes.map((time, index) => (
                                    <option key={index} value={time}>{time}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {selectedTime && user && useCurrentAddress === null && (
                        <div className="confirm-address-box">
                            <p>Your registered address is: <strong>{user.Address}</strong></p>
                            <p>Dose the service have to be performed at the same location?</p>
                            <div className="yes-no-buttons">
                                <button onClick={() => setUseCurrentAddress(true)}>Yes</button>
                                <button onClick={() => setUseCurrentAddress(false)}>No</button>
                            </div>
                        </div>
                    )}

                    {useCurrentAddress === false && (
                        <div className="temp-address-box">
                            <label>Srvice Location Address:</label>
			<div className="temp-address-fields">
                            <input
                                type="text"
                                value={tempAddress}
                                onChange={(e) => setTempAddress(e.target.value)}
                                required
                            />
				<label>Postal Code:</label>
				<input
  				type="text"
  				value={tempPostalCode}
  				onChange={(e) => {
    				let value = e.target.value.toUpperCase().replace(/\s/g, "");
    				if (value.length >= 3) {
      				value = value.slice(0, 3) + (value.length > 3 ? " " + value.slice(3) : "");
    				}
    				setTempPostalCode(value);
  				}}
  				required
                            />
				</div>
                        </div>
                    )}
                </div>
            </div>

            <div className="button-container">
                <button className="confirm-button" onClick={handleConfirm}>Confirm Appointment</button>
                <button className="cancel-button" onClick={() => navigate("/customer-dashboard")}>Back to Dashboard</button>
            </div>
        </div>
    );
}

export default SelectServices;
